import React, { useEffect, useMemo, useState } from 'react';
import ReactWebChat, { createDirectLine } from 'botframework-webchat';
import { DirectLine, ConnectionStatus } from 'botframework-directlinejs';
import { Box, Button, TextField, useTheme } from '@mui/material';
import { useAuth } from '../../../../hooks/useAuth';
import FallbackSpinner from '../../../../materio/@core/components/spinner';
import TestMessageComponent from '../../../TestHub/TestMessageComponent';
import ChatWrapper from './ChatWrapper';
import ChatSidebarLeft from './ChatSideBarLeft';
import AdminChatContent from './AdminChatContent';
import ChatMessage from '../admin-chat-client/ChatMessage';
import { useSettings } from '../../../../materio/@core/hooks/useSettings';
import ChatComponent from './ChatConnection';
import ChatClientStore from '../../stores/ChatClientStore';
import useChatClient from '../../hooks/useChatClient';

const ChatBotScreen = () => {
    const [directLine, setDirectLine] = useState<DirectLine | null>(null);
    const [conversationId, setConversationId] = useState<string | null>(null);
    const showChatWindow = ChatClientStore.useState(s => s.showChatWindow);
    const { loadChats, status, refreshChats } = useChatClient();

    //const [directLine, setDirectLine] = useState(new DirectLine({ token: '-kqNPC4Cgts.NvKsckZnSpBI-1fmMXlNW_7hYtXnIyszq48Kyft7ZDs' }));
    //const [conversationId, setConversationId] = useState(null);

    const { user } = useAuth();
    const theme = useTheme();

    useEffect(() => {
        loadChats();
    },[])

    useEffect(() => {
        const intervalId = setInterval(() => {
            refreshChats();
        }, 500);

        return () => clearInterval(intervalId);
    }, [status])

    useEffect(() => {
        const createDirectLine = async () => {
            if (showChatWindow) {
                const directLineToken = '-kqNPC4Cgts.NvKsckZnSpBI-1fmMXlNW_7hYtXnIyszq48Kyft7ZDs'; // Replace with your actual Direct Line token

                const dl = new DirectLine({
                    token: directLineToken,
                });

                // Listen for new messages and extract conversation ID
                dl.activity$.subscribe((activity) => {

                    console.log(activity);

                    if (activity.type === 'message' && activity.conversation) {
                        setConversationId(activity.conversation.id);

                        ChatClientStore.update(s => {
                            s.conversationId = activity.conversation!.id;
                        })
                    }
                });

                // You may want to handle other connection events here
                dl.connectionStatus$.subscribe((status) => {
                    if (status === ConnectionStatus.Online) {
                        console.log('Direct Line is online');
                    }
                });

                setDirectLine(dl);
            }
        };

        createDirectLine();
    }, [showChatWindow]);



    if (!user || directLine === null) return <FallbackSpinner />

    //return (
    //    <ChatComponent />
    //)

    //return (
    //    <ChatWrapper>
    //        <Button>New Conversation</Button>
    //        <Button>Join Conversation</Button>
    //        <ChatContent2 />
    //    </ChatWrapper>
    //)


    return (
        <Box sx={{ display: 'flex' }}>
            <ChatSidebarLeft />
            <ChatWrapper>
                {!showChatWindow && <AdminChatContent />}
                {showChatWindow && <ReactWebChat
                    directLine={directLine}
                    userID={user.id}
                    styleOptions={{
                        botAvatarImage: '',
                        botAvatarBackgroundColor: theme.palette.background.paper,
                        backgroundColor: theme.palette.background.default,
                        bubbleBackground: theme.palette.background.paper,
                        bubbleTextColor: 'white',

                    }}
                />}
            </ChatWrapper>
        </Box>

    )

    //return <TestMessageComponent />
}

ChatBotScreen.guestGuard = false;
ChatBotScreen.authGuard = true;

export { ChatBotScreen }

export default ChatBotScreen;